import { DI } from '@aurelia/kernel';
export const IAttrSyntaxTransformer = DI
    .createInterface('IAttrSyntaxTransformer')
    .noDefault();
//# sourceMappingURL=attribute-syntax-transformer.js.map